import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Cobble } from "./models/Cobble";

const moment = getMomentTz();

export const getCobbles = async (
	params: { shiftId: number; includeCorrections: boolean },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "ShiftId", value: params.shiftId },
		{ name: "IncludeCorrections", value: params.includeCorrections },
	];

	const resp = await apiService.callV2(
		"[M2].[GetCobblesByShift]",
		parameters,
		signal,
	);

	if (resp.ok) {
		let cobbles = get(resp, "data.tables[0].rows", []) as Cobble[];

		cobbles = cobbles.map((billet) => ({
			...billet,
			Start: moment.utc(billet["Start"]).toDate(),
			End: billet.End ? moment.utc(billet["End"]).toDate() : null,
			CorrectionAt: billet.CorrectedAt
				? moment.utc(billet["CorrectedAt"]).toDate()
				: null,
		}));

		return cobbles;
	} else {
		throw new Error(resp.message || "Error fetching cobbles");
	}
};

export const upsertCobble = async ({
	cobbleId,
	operatorId,
	isDelete,
	comment,
}: {
	cobbleId: number;
	operatorId: number;
	isDelete: boolean;
	comment?: string | null;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "BilletId", value: cobbleId },
		{ name: "OperatorId", value: operatorId },
		...(isDelete && comment ? [{ name: "Comment", value: comment }] : []),
	];

	var resp;

	if (isDelete) {
		resp = await apiService.callV2("[M2].[DeleteCobble]", parameters);
	} else {
		resp = await apiService.callV2("[M2].[UndeleteCobble]", parameters);
	}

	if (!resp.ok) {
		throw new Error(
			resp.message || `Error ${isDelete ? "deleting" : "undeleting"} cobble`,
		);
	}
};
